import clsx from "clsx";

export const baseStyles =
  "rounded-full w-8 h-8 flex items-center justify-center border-2 border-solid";

  export const variants = {
  completed: clsx(baseStyles, "border-[#1BB562]"),
  current: clsx(baseStyles, "border-[#00C5F2] "),
  upcoming: clsx(baseStyles, "border-[#A3B4D6]"),
} as const;